import { OyDomainType } from '@oy/types';
import * as Sentry from '@sentry/browser';
import axios from 'axios';
import { BLACKLIST_XHR_URL } from 'src/constants';

type HookErrorReportParams = {
  name: string;
  message: string;
  domain: OyDomainType;
  exception?: any;
};

export const reportHookError = ({
  name,
  message,
  domain,
  exception,
}: HookErrorReportParams) => {
  Sentry.addBreadcrumb({
    type: 'error',
    category: 'hook',
    level: 'error' as Sentry.SeverityLevel,
    data: { name, exception },
  });

  Sentry.withScope(scope => {
    scope.setTag('report.category', 'hook');
    scope.setTag('report.source', 'manual');
    scope.setTag('report.domain', domain);
    scope.setTag('report.platform', 'desktop');
    scope.setLevel('error' as Sentry.SeverityLevel);
    Sentry.captureMessage(`Error on ${name} hook: ${message}`);
  });
};

type FunctionErrorReportParams = {
  name: string;
  message: string;
  domain: OyDomainType;
  parentName?: string;
  exception?: any;
};

export const reportFunctionError = ({
  name,
  message,
  domain,
  exception,
  parentName,
}: FunctionErrorReportParams) => {
  if (axios.isAxiosError(exception)) return;

  Sentry.addBreadcrumb({
    type: 'error',
    category: 'function',
    level: 'error' as Sentry.SeverityLevel,
    data: { name, exception },
  });

  Sentry.withScope(scope => {
    scope.setTag('report.category', 'function');
    scope.setTag('report.source', 'manual');
    scope.setTag('report.domain', domain);
    scope.setTag('report.platform', 'desktop');
    scope.setLevel('error' as Sentry.SeverityLevel);
    Sentry.captureMessage(
      `Error on ${parentName || ''}${
        (parentName && '.') || ''
      }${name} function: ${message}`,
    );
  });
};

type ComponentErrorReportParams = {
  name: string;
  domain: OyDomainType;
  exception?: any;
};

export const reportComponentError = ({
  name,
  domain,
  exception,
}: ComponentErrorReportParams) => {
  Sentry.addBreadcrumb({
    type: 'error',
    category: 'component',
    level: 'error' as Sentry.SeverityLevel,
    data: { name, exception },
  });

  Sentry.withScope(scope => {
    scope.setTag('report.category', 'component');
    scope.setTag('report.source', 'manual');
    scope.setTag('report.domain', domain);
    scope.setTag('report.platform', 'desktop');
    scope.setLevel('error' as Sentry.SeverityLevel);
    Sentry.captureMessage(`Error on ${name} component rendering`);
  });
};

export const isBlacklistedXhrUrl = (url?: string) => {
  if (!url) return false;
  return !!BLACKLIST_XHR_URL.find(e => url.includes(e));
};
